import { useState, useEffect } from "react";
import { Table, Row, Col, Tooltip, User, Text } from "@nextui-org/react";
import { StyledBadge } from "./StyledBadge";
import { IconButton } from "./IconButton";
import { EyeIcon } from "./EyeIcon";
import ErrorInfo from "../auth/ErrorInfo";
import { useNotifications } from "reapop";
import { makeFetch } from "../../service/makeFetch";
import useStorage from "../storage/useLocalStorage";

export default function Logs() {
  const [userAuthenticated = false, setUserAuthenticated] =
    useStorage("userAuthenticated");
  const [_ = false, setDoingAction] = useStorage("doingAction");
  const [makeLogInfoVisible, setMakeLogInfoVisible] = useState(false);
  const [errInfo, setErrorInfo] = useState(null);
  const { notify } = useNotifications();
  const [allLogs = [], setAllLogs] = useStorage("allLogs");

  useEffect(() => {
    if (userAuthenticated === true) {
      getAllLogs();
    }
  }, [userAuthenticated]);

  const getAllLogs = async () => {
    setDoingAction(true);
    const result = await makeFetch({
      url: "logs/all",
      method: "GET",
      privateCall: false,
    });
    setDoingAction(false);
    if (result === undefined || result === null) {
      notify("Error getting logs failed!", "error");
      return;
    }
    if (result?.error === true) {
      notify(result.message, "error");
      return;
    }
    if (typeof window !== "undefined") {
      setAllLogs(
        result.data !== undefined &&
          result.data !== null &&
          result.data.length !== 0
          ? result.data.reverse()
          : []
      );
    }
  };

  const columns = [
    { name: "Sector", uid: "sector" },
    { name: "Date", uid: "date" },
    { name: "Message", uid: "message" },
    { name: "STATUS", uid: "status" },
    { name: "ACTIONS", uid: "actions" },
  ];

  const renderCell = (err, columnKey) => {
    const cellValue = err[columnKey];
    switch (columnKey) {
      case "name":
        return (
          <User squared src={err.avatar} name={cellValue} css={{ p: 0 }}>
            {err.email}
          </User>
        );
      case "role":
        return (
          <Col>
            <Row>
              <Text b size={14} css={{ tt: "capitalize" }}>
                {cellValue}
              </Text>
            </Row>
            <Row>
              <Text b size={13} css={{ tt: "capitalize", color: "$accents7" }}>
                {err.team}
              </Text>
            </Row>
          </Col>
        );
      case "status":
        return (
          <StyledBadge type={err.status === "error" ? "paused" : err.status}>
            Error
          </StyledBadge>
        );

      case "actions":
        return (
          <Row justify="center" align="center">
            <Col css={{ d: "flex" }}>
              <Tooltip content={"Click to view"}>
                <IconButton
                  onClick={() => {
                    setErrorInfo(err.meta);
                    setMakeLogInfoVisible(true);
                  }}
                >
                  <EyeIcon size={20} fill="#979797" />
                </IconButton>
              </Tooltip>
            </Col>
          </Row>
        );
      default:
        return cellValue;
    }
  };
  return (
    <ErrorInfo
      errInfo={errInfo}
      makeVisible={makeLogInfoVisible}
      setVisible={(e) => {
        setErrorInfo(null);
        setMakeLogInfoVisible(e);
      }}
    >
      <Table
        aria-label="Example table with custom cells"
        css={{
          height: "auto",
          minWidth: "100%",
        }}
        selectionMode="none"
      >
        <Table.Header columns={columns}>
          {(column) => (
            <Table.Column
              key={column.uid}
              hideHeader={column.uid === "actions"}
              align={column.uid === "actions" ? "center" : "start"}
            >
              {column.name}
            </Table.Column>
          )}
        </Table.Header>
        <Table.Body
          items={
            allLogs === null || allLogs === undefined || allLogs.length === 0
              ? []
              : allLogs
          }
        >
          {(item) => (
            <Table.Row>
              {(columnKey) => (
                <Table.Cell>{renderCell(item, columnKey)}</Table.Cell>
              )}
            </Table.Row>
          )}
        </Table.Body>
        <Table.Pagination
          shadow
          noMargin
          align="center"
          rowsPerPage={10}
          onPageChange={(page) => console.log({ page })}
        />
      </Table>
    </ErrorInfo>
  );
}
